import React from 'react'

import Checkbox from '../Fields/Checkbox'

import classes from './layout.css'
import content from '../../assets/content/content30.json'

const ModuleThirty = (props) => {
	return (
		<div className={classes.Container}>
			<p>Whether a procedure is easy or difficult, it is still a surgical procedure. All surgeries have some risks. For this surgery, they include the following and others:</p>
			<ol>
				{content.map((item, index) => {
					let itemNumber = index + 1
					let itemName = `cBox${itemNumber}`
					return (
						<li key={index}>
							<Checkbox
								controlFunc={props.addToForm}
								name={itemName}
								value={props.consentForm[itemName]}
							/>{item}
						</li>
					)
				})}
			</ol>
		</div>
	)
}

export default ModuleThirty


// WEBPACK FOOTER //
// ./src/components/Modules/30.js